import { Box, EventCard, Flex, Pagination, StatusLabel, Tag } from '@cowsquare/design';
import { navigate } from '@reach/router';
import { Link } from 'gatsby';
import * as R from 'ramda';
import React from 'react';
import styled, { css } from 'styled-components';
import { isExpired } from '../utils/isExpired';
import { isEventEnrolled } from '../utils/doctorUtils';

const EventCardBox = styled(Box).attrs({
  width: [1, 1 / 3],
  px: 4,
  pb: 5,
})`
  ${props =>
    props.expired &&
    css`
      opacity: 0.5;
    `}
`;

export const getItemProps = ({ item, uri }) => ({
  height: '295px',
  title: R.propOr('', 'name', item),
  status: isEventEnrolled(item) && <StatusLabel type="success">Enrolled</StatusLabel>,
  variant: 'vertical',
  date: R.propOr('', 'date', item),
  tags: R.pipe(
    R.propOr([], 'tags'),
    R.map(R.path(['tag', 'name'])),
    R.map(tag => (
      <Tag
        key={tag}
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
          navigate(`${uri}?tag=${tag}`);
        }}
      >
        {tag}
      </Tag>
    ))
  )(item),
  cardInfoData: R.pipe(
    R.pick(['score', 'organizer', 'location']),
    R.reject(R.anyPass([R.isNil, R.isEmpty])),
    R.evolve({
      score: value => ({
        icon_name: 'POINT',
        text: value,
      }),
      organizer: value => ({
        icon_name: 'ORGANIZATION',
        text: R.propOr('', ['name'], value),
      }),
      location: value => ({
        icon_name: 'LOCATION',
        text: value,
      }),
    }),
    R.values,
    R.when(R.isEmpty, R.always(null))
  )(item),
});

export const EventCardList = ({
  uri,
  page,
  pageSize = 20,
  onPageChange,
  list = [],
  total = 0,
  options = () => {},
}) => {
  const showPagination = total > pageSize;

  return (
    <>
      <Box mt={5} mx={-4}>
        <Flex flexWrap="wrap">
          {R.map(
            item => (
              <EventCardBox key={item.id} expired={isExpired(item.date)}>
                <EventCard
                  as={Link}
                  to={`${uri}/${R.propOr('', 'id', item)}`}
                  {...getItemProps({ item, uri })}
                  {...options(item)}
                />
              </EventCardBox>
            ),
            list
          )}
        </Flex>
      </Box>
      {/** TODO: Pagination 直接由外部決定要不要顯示
      https://github.com/cowsquare/cowsquare-mono/pull/58#discussion_r302190214
       */}
      {showPagination && (
        <Box mt={8}>
          <Flex justifyContent="center">
            <Pagination pageSize={pageSize} current={page} total={total} onChange={onPageChange} />
          </Flex>
        </Box>
      )}
    </>
  );
};
